<template>
	<div class="mb-5">
		<a class="anchor" id="contact"></a>
		<span class="d-block pt-5">&nbsp;</span>
		<div v-if="form == 'email'">
			<ContactFormEmail />
		</div>
		<div v-else-if="form == 'phone'">
			<ContactFormPhone />
		</div>
		<div v-else-if="form == 'address'">
			<ContactFormAddress />
		</div>
		<div v-else-if="form == 'general'">
			<ContactFormGeneral />
		</div>
		<div v-else>
			<ContactFormGeneral />
		</div>

	</div>
</template>

<script>
	import axios from 'axios'
	import ContactFormGeneral from '@/components/ContactFormGeneral.vue'
	import ContactFormPhone from '@/components/ContactFormPhone.vue'
	import ContactFormEmail from '@/components/ContactFormEmail.vue'
	import ContactFormAddress from '@/components/ContactFormAddress.vue'

	export default {
		data() {
			return{
				form: null
			}
		},
		components: {
			ContactFormGeneral,
			ContactFormPhone,
			ContactFormEmail,
			ContactFormAddress
		},
		mounted() {
			axios.get('https://ango.waw.pl/api/options/').then(response => (this.form = response.data.contactForm))
		}
	}

</script>